export default __webpack_public_path__ + "static/media/mojaco_bow.135534f4.png";